<template>
    <Teleport to="body">
        <div
            class="fixed top-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-96 z-[60] flex flex-col gap-2 pointer-events-none pt-[env(safe-area-inset-top)]"
            aria-live="polite"
        >
            <TransitionGroup
                enter-active-class="transition ease-out duration-300"
                enter-from-class="opacity-0 translate-y-2 sm:translate-x-4 sm:translate-y-0"
                enter-to-class="opacity-100 translate-y-0 sm:translate-x-0"
                leave-active-class="transition ease-in duration-200"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0 translate-y-2 sm:translate-x-4 sm:translate-y-0"
            >
                <div
                    v-for="toast in toastStore.toasts"
                    :key="toast.id"
                    class="pointer-events-auto flex items-start gap-3 p-4 rounded-lg shadow-lg border"
                    :class="toastStyles[toast.type]"
                    :role="toast.type === 'error' ? 'alert' : 'status'"
                >
                    <component
                        :is="toastIcons[toast.type]"
                        class="h-5 w-5 flex-shrink-0 mt-0.5"
                    />
                    <p class="flex-1 text-sm break-words whitespace-pre-line">
                        {{ toast.message }}
                    </p>
                    <button
                        type="button"
                        class="flex-shrink-0 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-1 opacity-60 hover:opacity-100 transition-opacity"
                        :class="toastDismissRings[toast.type]"
                        :aria-label="t('common.close')"
                        @click="toastStore.dismiss(toast.id)"
                    >
                        <X class="h-4 w-4" />
                    </button>
                </div>
            </TransitionGroup>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
import { X, CheckCircle2, XCircle, AlertTriangle, Info } from "@lucide/vue";
import { useI18n } from "vue-i18n";
import { useToastStore } from "@/stores/toastStore";

const { t } = useI18n();
const toastStore = useToastStore();

const toastIcons = {
    success: CheckCircle2,
    error: XCircle,
    warning: AlertTriangle,
    info: Info,
};

const toastStyles = {
    success:
        "bg-success-50 dark:bg-success-900/30 border-success-300 dark:border-success-700 text-success-800 dark:text-success-200",
    error: "bg-danger-50 dark:bg-danger-900/30 border-danger-300 dark:border-danger-700 text-danger-800 dark:text-danger-200",
    warning:
        "bg-warning-50 dark:bg-warning-900/30 border-warning-300 dark:border-warning-700 text-warning-800 dark:text-warning-200",
    info: "bg-primary-50 dark:bg-primary-900/30 border-primary-300 dark:border-primary-700 text-primary-800 dark:text-primary-200",
};

const toastDismissRings = {
    success: "focus:ring-success-500",
    error: "focus:ring-danger-500",
    warning: "focus:ring-warning-500",
    info: "focus:ring-primary-500",
};
</script>
